import { isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';
import menuHandler from './menuHandler';

const toggleMenu = (menu, menuOpen, menuClose) => {
  if (!menu || !menuOpen || !menuClose) return;

  window.addEventListener('scroll', (e) => {
    e.preventDefault();
    menu.classList.contains('menu--open') ? window.scrollTo(0, 0) : document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  });

 
  const customCareButton = document.getElementById('custom-care-button');
  const html = document.getElementsByTagName('html')[0];
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  let timeout = null;
  menuOpen.onclick = (event) => {
    event.preventDefault();
    document.body.style.position = '';
    document.body.style.scrollbarGutter = 'stable';
    menu.classList.add('menu--open');
    document.getElementsByTagName('main')[0].marginTop = '0px';
    if (isMobileScreen(BREAKPOINTS.LG)) {
      document.body.style.height = '-webkit-fill-available';
      document.documentElement.style.height = '-webkit-fill-available';

    }
    const ot = document.getElementById('ot-sdk-btn-floating');
    if (ot) {
      ot.style.display = 'none';
    }

    if (customCareButton) {
      customCareButton.style.display = 'none';
    }

    if (isSafari) {
      timeout = setTimeout(() => {
        html.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        menu.style.overflow = 'hidden';
      }, 1000);

    }
    html.classList.add('menu__scroll');
    document.body.style.scrollbarColor = '#c2c2c2 transparent';
  };

  menuClose.onclick = (event) => {
    event.preventDefault();
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.scrollbarGutter = '';
    document.body.style.top = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    menu.classList.remove('menu--open');
    document.getElementsByTagName('main')[0].marginTop = '76px';
    if (isMobileScreen(BREAKPOINTS.LG)) {
      document.body.style.height = '100%';
      document.documentElement.removeAttribute('style');
    }
    const ot = document.getElementById('ot-sdk-btn-floating');
    if (ot) {
      ot.style.display = 'block';
    }

    if (customCareButton) {
      customCareButton.style.display = 'block';
    }

    html.classList.remove('menu__scroll');
    document.body.style.scrollbarColor = 'unset';
    if (isSafari) {
      clearTimeout(timeout);
    }
  };
};

const expandItems = (expand) => {

  const open = expand.classList.contains('expand--open');
  const openedElements = expand.parentElement.querySelectorAll('.expand--open');

  if (!open) {
    openedElements.forEach((item) => {
      item.classList.remove('expand--open');
      item.setAttribute('aria-expanded', 'false');

      if (!item.classList.contains('menu__list-item')) {
        const dropdown = item.querySelector('.nav__list-item-dropdown');
        if (dropdown) dropdown.style.maxHeight = '0';
      }
    });

    expand.classList.add('expand--open');
    expand.setAttribute('aria-expanded', 'true');
    const dropdown = expand.querySelector('.nav__list-item-dropdown');
    if (dropdown && !expand.classList.contains('menu__list-item')) {
      dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
      dropdown.addEventListener('mouseleave', () => {
        expand.classList.remove('expand--open');
        expand.setAttribute('aria-expanded', 'false');
        dropdown.style.maxHeight = '0';
        dropdown.removeEventListener('mouseleave', null);
      });
    }

    expand.addEventListener('click', () => {
      expand.classList.remove('expand--open');
      expand.setAttribute('aria-expanded', 'false');
      expand.removeEventListener('click', null);
    });
    return;
  }
};

const onMouseOver = (e) => {
  e.preventDefault();
  const targetEl = e.target;

  if (targetEl.classList.contains('expand')) return expandItems(targetEl);
  expandItems(targetEl);

};

const onNavbarLoad = () => {
  const expand = document.querySelectorAll('.nav  .nav__left .nav__list-item');

  if (!expand) return;

  expand.forEach((item) => {
    item.addEventListener('mouseenter', onMouseOver);
  });

  const menu = document.querySelector('.menu');
  const menuOpen = document.querySelector('#menuOpen');
  const menuClose = document.querySelector('#menuClose');
  toggleMenu(menu, menuOpen, menuClose);
  menuHandler(menu);
};

export default onNavbarLoad;
